import Helpers from '../Helpers'
import {modules} from '../Modules'

/* eslint-disable quotes, max-len */
export default function getDefaultData(time) {
  const stringedModules = JSON.stringify(modules)
  const modifiedStringModules = Helpers.resetTimeValue(stringedModules, time)
  return JSON.parse(modifiedStringModules)
}
